<template>
  <v-dialog v-model="dialog" max-width="960px">
    <template v-slot:activator="{ on, attrs }">
      <v-card
        v-bind="text ? attrs : null"
        v-on="text ? on : null"
        class="py-6 py-sm-10 px-3 item"
        height="100%"
        flat
        tile
      >
        <img
          class="d-block mx-auto item-img"
          :src="files + img"
          :alt="title"
          height="90px"
          width="90px"
        />

        <div
          class="
            grey--text
            text--darken-2 text-body-2 text-sm-h6 text-center
            mt-3
            item-title
          "
          :class="{ 'font-weight-bold': xsOnly }"
        >
          {{ title }}
        </div>
      </v-card>
    </template>

    <v-card class="py-10 px-3 px-md-5 position-relative item" flat tile>
      <div class="model-close">
        <v-btn
          @click="dialog = false"
          color="grey darken-3"
          width="38px"
          height="38px"
          depressed
          fab
        >
          <v-icon color="white" size="20"> fa-times </v-icon>
        </v-btn>
      </div>

      <img
        class="d-block mx-auto item-img"
        :src="files + img"
        :alt="title"
        height="90px"
        width="90px"
      />

      <div
        class="
          primary--text
          text-h6 text-md-h5 text-center
          mt-3
          font-weight-bold
          item-title
        "
      >
        {{ title }}
      </div>

      <div
        class="grey--text text--darken-1 text-body-1 mt-4 ck-content"
        v-html="text"
      ></div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid #d9d9d9;

  &-img {
    -o-object-fit: contain;
    object-fit: contain;
    -o-object-position: center;
    object-position: center;
  }

  &-title {
    line-height: 1.2;
  }
}

.model-close {
  top: 10px;
  right: 10px;
}
</style>
